import { Tabs } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ErrorMessages, triggerNotification, useGetApiRequests } from "../../../../common/CommonExport";
import {
  calculateEmployeeContribution,
  calculateEmployerContribution,
  calculateFixedEmployerContribution,
  calculateGrossMonthlyYearly,
  calculateSalaryParticulars,
  calculationForCtc,
  calculationForNetAmount,
  calculationForTotalAmount,
  gratuityCalculation,
} from "../../../employee/employee-details/employee-profile/layout/salary-component/SalaryClaculationFunctions";
import { filterNavigationItems } from "../../../../common/permissionController";
import ModalLoader from "../../../../components/Loader/ModalLoader";
import UserSalaryComponent from "./UserSalaryComponent";
import UserBonus from "./UserBonus";
import UserSalaryHistory from "./UserSalaryHistory";
import noRecordFound from "../../../../assets/images/empty-folder.png";

const { TabPane } = Tabs;

export default function UserSalaryDetails() {
  const rolePermissions = useSelector((state: any) => state?.rolePermissions?.rolePermissions);
  const employeePermission = useSelector((state: any) => state?.employeePermissionSlice?.employeePermission);
  const employeeDetails = useSelector((state: any) => state?.employee?.employeeDetails);
  const userId = useSelector((state: any) => state?.userId?.id);

  const [activeTabKey, setActiveTabKey] = useState("1");
  const orgId = useSelector((state: any) => state?.organisationId?.id);
  const { id }: any = useParams();

  const [salaryParticulars, setSalaryParticulars] = useState<any>([]);
  const [employeeContribution, setEmployeeContribution] = useState<any>([]);
  const [employerContribution, setEmployerContribution] = useState<any>([]);
  const [grossSalary, setGrossSalary] = useState({ grossAmountMonthly: NaN, grossAmountAnnual: NaN });
  const [costToCompany, setCostToCompany] = useState({ ctcMonthly: NaN, ctcYearly: NaN });
  const [netAmount, setNetAmount] = useState({ monthly: NaN, yearly: NaN });
  const [showNull, setShowNull] = useState<any>(null);
  const [isEdit, setIsEdit] = useState(false);
  const [fixedEmployerContribution, setFixedEmployerContribution] = useState([]);
  const [loader, setLoader] = useState(false);
  const [salaryTab, setSalaryTab] = useState<any>([]);
  const [combineEmployerArray, setCombineEmployerArray] = useState<any>([]);

  const getInternEmployeeSalary = useGetApiRequests("employeeInternType", "GET");

  const getRegularEmployeeSalary = useGetApiRequests("getEmployeeSalaryComponents", "GET");

  const salaryRange = useGetApiRequests("getSalaryRange", "GET");
  const employeeSalaryRange = useGetApiRequests("employeeSalaryRange", "GET");

  const employeeSalaryGeTApi = () => {
    const useType = employeeDetails?.employeeType?.typeofEmployment;

    if (employeePermission) {
      if (useType === "Regular") {
        regularEmployeeSalary();
      } else {
        getInternSideLables();
      }
    }
  };

  const checkValueGreaterThanZero = (value: any) => {
    if (Number(value) > 0) {
      return Number(value);
    }
    return 0;
  };
  useEffect(() => {
    employeeSalaryGeTApi();
  }, []);

  const regularEmployeeSalary = () => {
    setLoader(true);
    const params: any = {
      organisationId: orgId,
    };
    getRegularEmployeeSalary("", params)
      .then((response: any) => {
        handleRegularApiResponse(response);
      })
      .catch((err: any) => {
        setTimeout(() => {
          setLoader(false);
        }, 1000);
        triggerNotification("error", "", ErrorMessages.somethingWentWrong, "topRight");
      });
  };

  const handleRegularApiResponse = (response: any) => {
    const apiResponse = response?.data?.data;
    const salaryParticularsData = apiResponse.filter((item: any) => item.groupName === "Salary Particulars").map((obj: any) => ({ ...obj, monthly: "", yearly: "" }));
    const employeeContributionData = apiResponse.filter((item: any) => item.groupName === "Employee Contribution").map((obj: any) => ({ ...obj, monthly: "", yearly: "" }));
    const employerContributionData = apiResponse.filter((item: any) => item.groupName === "Employer Contribution").map((obj: any) => ({ ...obj, monthly: "", yearly: "" }));
    const tempFixedEmployerContribution = calculateFixedEmployerContribution(apiResponse);
    // setFixedEmployerContribution(tempFixedEmployerContribution)
    getSalaryHistoryList(salaryParticularsData, employeeContributionData, employerContributionData, tempFixedEmployerContribution, "1");
  };

  const getInternSideLables = () => {
    setLoader(true);
    const params: any = {
      id: employeeDetails?.employeeType?.employeeTypeId,
    };
    getInternEmployeeSalary("", "", params)
      .then((response: any) => {
        const apiResponse = response?.data?.data.emoyeeTypeSalaryComponentMap;
        const salaryParticularsData = apiResponse
          .filter((item: any) => item.salaryComponent.groupName === "Salary Particulars")
          .map((obj: any) => ({ ...obj.salaryComponent, monthly: "", yearly: "" }));
        const employeeContributionData = apiResponse
          .filter((item: any) => item.salaryComponent.groupName === "Employee Contribution")
          .map((obj: any) => ({ ...obj.salaryComponent, monthly: "", yearly: "" }));
        const employerContributionData = apiResponse
          .filter((item: any) => item.salaryComponent.groupName === "Employer Contribution")
          .map((obj: any) => ({ ...obj.salaryComponent, monthly: "", yearly: "" }));

        const tempFixedEmployerContribution = calculateFixedEmployerContribution(apiResponse);
        setFixedEmployerContribution(tempFixedEmployerContribution);
        getSalaryHistoryList(salaryParticularsData, employeeContributionData, employerContributionData, tempFixedEmployerContribution, "2");

        const combinedArray = [...new Set([...employerContributionData, ...tempFixedEmployerContribution])];
        setCombineEmployerArray(combinedArray);
      })
      .catch((err: any) => {
        setTimeout(() => {
          setLoader(false);
        }, 1000);
        triggerNotification("error", "", ErrorMessages.internalServerError, "topRight");
      });
  };

  const fetchSalaryRange = (apiFunction: Function, salaryParticularsData: any, employeeContributionData: any, employerContributionData: any, tempFixedEmployerContribution: any, type: string) => {
    const param = {
      id: userId,
      end: "salary/history/range",
    };

    apiFunction("", "", param)
      .then((response: any) => {
        if (response?.data?.status.success.toLowerCase() === "success" && response?.data?.data) {
          const tempSalaryDetails = response?.data?.data[0];
          setIsEdit(true);
          setShowNull("not a null");
          setSalaryValues(tempSalaryDetails, salaryParticularsData, employeeContributionData, employerContributionData, tempFixedEmployerContribution, type);
        } else {
          setShowNull(response?.data?.data);
        }
        setLoader(false);
      })
      .catch((error: any) => {
        setTimeout(() => {
          setLoader(false);
        }, 1000);
        triggerNotification("error", "", error?.response?.data?.message, "topRight");
      });
  };


  const getSalaryHistoryList = (salaryParticularsData: any, employeeContributionData: any, employerContributionData: any, tempFixedEmployerContribution: any, type: string) => {
    setLoader(true);

    if (employeePermission) {
      const param = {
        id: userId,
        end: "salary/range",
      };
      employeeSalaryRange("", "", param)
        .then((response: any) => {
          if (response?.data?.status.success.toLowerCase() === "success" && response?.data?.data) {
            const tempSalaryDetails = response?.data?.data;
            setIsEdit(true);
            setShowNull("not a null");
            if (tempSalaryDetails.status.toLowerCase() === "draft") {
              fetchSalaryRange(employeeSalaryRange, salaryParticularsData, employeeContributionData, employerContributionData, tempFixedEmployerContribution, type);

            } else if (tempSalaryDetails.status.toLowerCase() === "publish") {
              setIsEdit(false);
              if (tempSalaryDetails !== null) {
                setSalaryValues(tempSalaryDetails, salaryParticularsData, employeeContributionData, employerContributionData, tempFixedEmployerContribution, type);
              }
            }
          } else {
            setShowNull(response?.data?.data);
          }
          setLoader(false);
        })
        .catch((error) => {
          setTimeout(() => {
            setLoader(false);
          }, 1000);
          triggerNotification("error", "", error.response.data.message, "topRight");
        });
    } else {
      const param = {
        id: id,
        end: "salary/range",
      };
      salaryRange("", "", param)
        .then((response: any) => {
          if (response?.data?.status.success.toLowerCase() === "success" && response?.data?.data) {
            setShowNull("not a null");
            const tempSalaryDetails = response?.data?.data;
            setIsEdit(true);
            if (tempSalaryDetails.status.toLowerCase() === "draft") {
              fetchSalaryRange(salaryRange, salaryParticularsData, employeeContributionData, employerContributionData, tempFixedEmployerContribution, type);

            } else if (tempSalaryDetails.status.toLowerCase() === "publish") {
              setIsEdit(false);
              if (tempSalaryDetails !== null) {
                setSalaryValues(tempSalaryDetails, salaryParticularsData, employeeContributionData, employerContributionData, tempFixedEmployerContribution, type);
              }
            }

          } else {
            setShowNull(response?.data?.data);
          }
        })
        .catch((error) => {
          setTimeout(() => {
            setLoader(false);
          }, 1000);
          triggerNotification("error", "", error.response.data.message, "topRight");
        });
    }
  };

  const setSalaryValues = (salaryDetails: any, salaryParticularsData: any, employeeContributionData: any, employerContributionData: any, tempFixedEmployerContribution: any, type: any) => {
    const updatedSalaryParticulars = calculateSalaryParticulars(salaryDetails, salaryParticularsData);
    const updatedEmployerContribution = calculateEmployerContribution(salaryDetails, employerContributionData);
    const updatedEmployeeContribution = calculateEmployeeContribution(salaryDetails, employeeContributionData);
    const daComponent = updatedSalaryParticulars.find((item: any) => item.code === 'DA');
    // const daAmount = daComponent.yearly;
    const daAmount = daComponent?.monthly;
    const gratuityValueArray = gratuityCalculation(salaryDetails.employeeSalaryDetails[0].monthly, updatedEmployerContribution, daAmount);
    setFixedEmployerContribution(gratuityValueArray);
    const { grossAmountMonthly, grossAmountAnnual } = calculateGrossMonthlyYearly(orgId, salaryDetails, updatedSalaryParticulars);
    setGrossSalary({ grossAmountMonthly: grossAmountMonthly, grossAmountAnnual: grossAmountAnnual });
    if (type === "2") {
      const monthlyCtc: any = calculationForCtc(salaryDetails, updatedEmployerContribution);
      const { totalAnnual } = calculationForTotalAmount(salaryDetails, grossAmountAnnual, updatedEmployeeContribution, updatedSalaryParticulars);
      setCostToCompany({ ctcMonthly: monthlyCtc, ctcYearly: totalAnnual });
    } else if (type === "1") {
      const { tempMonthlyCTC, tempYearlyCTC } = calculateCTC(grossAmountMonthly, [], gratuityValueArray);
      setCostToCompany({ ctcMonthly: tempMonthlyCTC, ctcYearly: tempYearlyCTC });
    }
    const { netAmountMonthly, netAmountAnnual } = calculationForNetAmount(updatedEmployeeContribution, grossAmountMonthly, grossAmountAnnual, salaryDetails);
    setNetAmount({ monthly: netAmountMonthly, yearly: netAmountAnnual });
    setSalaryParticulars(updatedSalaryParticulars);
    setEmployerContribution(updatedEmployerContribution);
    setEmployeeContribution(updatedEmployeeContribution);
    setCombineEmployerArray(gratuityValueArray);
  };
  const calculateCTC = (grossMonth: any, employerContribution: any, tempFixedEmployerContribution: any) => {
    const tempEmployerContribution: any = [...employerContribution];
    const fixedEmployerContributionTemp = [...tempFixedEmployerContribution];
    let tempMonthlyCTC: number = grossMonth;
    tempEmployerContribution.forEach((item: any) => {
      tempMonthlyCTC = tempMonthlyCTC + Number(item.monthly);
    });
    fixedEmployerContributionTemp.forEach((item: any) => {
      if (item.name === "ESI") {
        if (grossMonth <= 21000) {
          item.monthly = (checkValueGreaterThanZero(grossMonth) * 3.25) / 100;
          item.yearly = Number((checkValueGreaterThanZero(grossMonth) * 3.25) / 100) * 12;
        } else {
          item.monthly = 0;
          item.yearly = 0;
        }
      }
      tempMonthlyCTC = tempMonthlyCTC + Number(item.monthly);
    });
    let tempYearlyCTC: number = tempMonthlyCTC * 12;

    fixedEmployerContributionTemp.forEach((item: any) => {
      if (item.monthly === 0) {
        tempYearlyCTC += item.yearly;
      }
    });
    // tempYearlyCTC = tempYearlyCTC;

    return { tempMonthlyCTC, tempYearlyCTC };
  };

  const handleTabChange = (key: string) => {
    setActiveTabKey(key);
  };

  const filteredNavigationItems = useMemo(() => {
    const items = [
      {
        key: "1",
        label: "Particulars",
        children: (
          <UserSalaryComponent
            showNull={showNull}
            salaryParticulars={salaryParticulars}
            employeeContribution={employeeContribution}
            employerContribution={employerContribution}
            grossSalary={grossSalary}
            costToCompany={costToCompany}
            netAmount={netAmount}
            fixedEmployerContribution={fixedEmployerContribution}
            combineEmployerArray={combineEmployerArray}
          />
        ),
        permission: "Salary Particulars",
      },
      {
        key: "2",
        label: "Bonus",
        children: <UserBonus />,
      },
      {
        key: "3",
        label: "History",
        children: <UserSalaryHistory />,
        permission: "Salary History",
      },
    ];
    return filterNavigationItems(items, rolePermissions);
  }, [combineEmployerArray, costToCompany, employeeContribution, employerContribution, fixedEmployerContribution, grossSalary, netAmount, rolePermissions, salaryParticulars, showNull]);

  useEffect(() => {
    setSalaryTab(filteredNavigationItems);
  }, [filteredNavigationItems]);

  return (
    <div className="salary_details font-rubik">
      {salaryTab?.length > 0 ? (
        <div className="">
          <div className="grid grid-cols-1 gap-4 relative">
            <Tabs activeKey={activeTabKey} onChange={handleTabChange}>
              <TabPane key="1" tab="Particulars">
                <UserSalaryComponent
                  showNull={showNull}
                  salaryParticulars={salaryParticulars}
                  employeeContribution={employeeContribution}
                  employerContribution={employerContribution}
                  grossSalary={grossSalary}
                  costToCompany={costToCompany}
                  netAmount={netAmount}
                  fixedEmployerContribution={fixedEmployerContribution}
                  combineEmployerArray={combineEmployerArray}
                />
              </TabPane>

              <TabPane key="3" tab="History">
                <UserSalaryHistory />
              </TabPane>

              {/* {salaryTab?.map((item: any) => (
                <TabPane key={item.key} tab={item.label}>
                  {item.children}
                </TabPane>
              ))} */}
            </Tabs>
          </div>
        </div>
      ) : (
        <div className="no-record flex justify-center items-center  no-record-documents absolute">
          <p className="flex justify-center items-center text-xl">
            {" "}
            <img src={noRecordFound} alt="" />
          </p>
        </div>
      )}
      {loader && <ModalLoader />}
    </div>
  );
}
